module.exports = __webpack_public_path__ + "img/toum.5febd2a0.png";